import { styles as componentStyles } from './view.scss';
import { styles as commonStyles } from '../../../../../assets/common.scss';
import { styles as lpWidgetsCommonStyles } from '../../../../view/landingPageWidgetsCommonStyles.scss';
import { unsafeCSS } from 'lit';

export const styles = [
  unsafeCSS(`${componentStyles}`),
  unsafeCSS(`${commonStyles}`),
  unsafeCSS(`${lpWidgetsCommonStyles}`),
];
